import BasicDetails from "./components/basicDetails";
import SubTotal from "./components/subTotal";
import InvoiceTable from "./components/table";


const DefaultInvoice = ({ children }) => {
    return (
        <div className="flex flex-col gap-8">
            {children}
        </div>
    );
};

export default DefaultInvoice;
